<!-- BedsCell.vue -->
<template>
  <div>
    <!-- Non-Admin View: Formatted layout with Modal -->
    <template v-if="!isAdminRole">
      <div v-b-modal="modalId" class="cursor-pointer">
        <strong class="font-weight-bold d-block">
          {{ displayType }}
        </strong>
        <small v-if="displaySpecs" class="text-muted d-block" style="line-height: 1.1;">
          {{ displaySpecs }}
        </small>
      </div>
    </template>

    <!-- Admin View: Simple display -->
    <span v-else>{{ displayType }}</span>
  </div>
</template>

<script>
export default {
  props: {
    // The full row object
    row: { type: Object, required: true },
    // The custom_field_mls_beds_value object { type: "...", fp_specs: "..." }
    bedsData: { type: Object, default: () => ({ type: "", fp_specs: "" }) },
    userRole: { type: String, default: "" },
    listingType: { type: String, default: "" }
  },
  computed: {
    isAdminRole() {
      return ['admin'].includes(this.userRole);
    },
    displayType() {
      // Use the pre-formatted 'type' from your data sample
      return this.bedsData && this.bedsData.type ? this.bedsData.type : "";
    },
    displaySpecs() {
      // Use the pre-formatted 'fp_specs' from your data sample
      return this.bedsData && this.bedsData.fp_specs ? this.bedsData.fp_specs : "";
    },
    modalId() {
      return `mls-${this.listingType}-${this.row.cid}`;
    }
  }
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.cursor-pointer:hover strong {
  text-decoration: underline;
  color: #007bff; /* Optional: standard link color on hover */
}
</style>
